var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKlarna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3619 11.9014C15.2674 11.9014 14.3801 12.8188 14.3801 13.9507C14.3801 15.0822 15.2674 15.9998 16.3619 15.9998C17.4565 15.9998 18.3439 15.0822 18.3439 13.9507C18.3439 12.8188 17.4565 11.9014 16.3619 11.9014Z",
    fill: "#17120F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2415 0H8.8161C8.8161 2.90296 7.52527 5.56742 5.27471 7.3106L3.9176 8.36146L9.17594 15.7754H13.4993L8.66093 8.95344C10.9544 6.59205 12.2415 3.41512 12.2415 0Z",
    fill: "#17120F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.7748H3.50138V0H0V15.7748Z",
    fill: "#17120F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlarna);
export default __webpack_public_path__ + "static/media/klarna.886e51047a910b9d32a3c2f97c0860db.svg";
export { ForwardRef as ReactComponent };